import AirDatepicker from "air-datepicker";
import localeEn from 'air-datepicker/locale/en';

const PeriodDatePicker = () => {
  const inputFrom = document.querySelector("input#order-date-from");
  const inputTo = document.querySelector("input#order-date-to");
  const containerFrom = document.querySelector(".calendar-date-from");
  const containerTo = document.querySelector(".calendar-date-to");

  let calendarInstanceFrom = null;
  let calendarInstanceTo = null;

  if (containerFrom) {
    calendarInstanceFrom = new AirDatepicker(containerFrom, {
      locale: localeEn,
      autoClose: true,
      view: 'days',
      minView: 'days',
      onSelect({ date }) {
        if (date) {
          calendarInstanceTo.update({
            minDate: date,
          });

          const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }).replace(/\//g, '.');
          inputFrom.value = formattedDate;

          containerFrom.classList.remove('visible');  
        }
      }
    });
  }

  if (containerTo) {
    calendarInstanceTo = new AirDatepicker(containerTo, {
      locale: localeEn,
      autoClose: true,
      view: 'days',
      minView: 'days',
      onSelect({ date }) {
        if (date) {
          calendarInstanceFrom.update({
            maxDate: date,
          });

          const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }).replace(/\//g, '.');
          inputTo.value = formattedDate;

          containerTo.classList.remove('visible');  
        }
      }
    });
  }

  if (inputFrom) {
    inputFrom.addEventListener('click', () => {
      containerFrom.classList.add('visible');
      if (containerTo) {
        containerTo.classList.remove('visible'); 
      }
    });
  }

  if (inputTo) {
    inputTo.addEventListener('click', () => {
      containerTo.classList.add('visible');
      if (containerFrom) {
        containerFrom.classList.remove('visible'); 
      }
    });
  }

  document.addEventListener("click", (event) => {
    if (
      containerFrom &&
      !inputFrom.contains(event.target) &&
      !containerFrom.contains(event.target)
    ) {
      containerFrom.classList.remove('visible');
    }

    if (
      containerTo &&
      !inputTo.contains(event.target) &&
      !containerTo.contains(event.target)
    ) {
      containerTo.classList.remove('visible');
    }
  });
};

export default PeriodDatePicker;

